import { Store } from "../store";
import { EGiftTransaction } from "./EGiftTransaction.model";

export class EGiftCardPool {
	cardNumber: string;
	venueKey: number;
	activated: boolean;
	created: Date;
	activatedDateTime: Date;
	transactionKey: string;
	cardBalance: number;

	EGiftTransaction: EGiftTransaction[];

	Venue: Store;

	public constructor(init?: Partial<EGiftCardPool>) {
		Object.assign(this, init);
	}
}
